export default "__VITE_ASSET__DGF5IrTT__"